import { Store } from "./store";

export class VenueInternet {
	venueKey: number;
	disconnectDateTime: Date;
	duration: number;

	Venue?: Store;

	public constructor(init?: Partial<VenueInternet>) {
		Object.assign(this, init);
	}
}
